import {useContext} from "react";
import {GlobalContext} from "../../../util/state/GlobalContextProvider";
import {useSalesMarketingApi} from "./useSalesMarketingApi";
import qs from "qs";


export const useProcurerActions = () => {
    const { GET, PUT } = useSalesMarketingApi();
    const { globalData } = useContext(GlobalContext);

    async function listProcurers(filters: any) {
        let params = {
            tenantId: filters.legalEntity ? filters.legalEntity : undefined,
            dealerId: filters.dealer ? filters.dealer : undefined,
            search: filters.search ? filters.search : undefined,
            repCompanyName: filters.companyName ? filters.companyName : undefined,
            repVatNumber: filters.vatNumber ? filters.vatNumber : undefined,
            siren: filters.siren ? filters.siren : undefined,
            genBpCode: filters.idSAP ? filters.idSAP : undefined,
            code: filters.vendorCode ? filters.vendorCode : undefined,
            offset: filters.offset,
            limit: filters.limit,
            sort: filters.sort ? filters.sort : undefined,
            order: filters.order ? filters.order : undefined
        }
        let data = (await GET("/sm/affiliationprogram/procurer/", true, {
            params: params,
            paramsSerializer: (params: any) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        })).result;
        let list:any[] = [];
        data?.content?.forEach((el:any) => {
            list.push({
                tenantId: globalData.user.legalEntities.find((le:any) => le.name == el?.tenantId)?.name,
                dealerId: globalData.user.dealers.find((d:any) => d.name == el?.dealerId)?.name,
                repCompanyName: el.repCompanyName,
                repVatNumber: el.repVatNumber,
                siren: el.siren,
                siret: el.siret,
                genBpCode: el.genBpCode,
                genVendorCode: el.genVendorCode
            });
        });
        return {
            content: list,
            totalElements: data.totalElements
        }
    }

    async function detailProcurer(id: string) {
        let res = (await GET("/sm/affiliationprogram/procurer/" + id, true)).result;
        return {
            tenantId: globalData.user.legalEntities.find((le:any) => le.name == res?.tenantId)?.name,
            dealerId: globalData.user.dealers.find((d:any) => d.name == res?.dealerId)?.name,

            genVendorCode: res?.genVendorCode,
            status: res?.genStatus,
            commercialCode: res?.procConCommercial,
            
            naming: res?.genProcurerNaming,
            bpCode: res?.genBpCode,
            serviceType: res?.genServiceType,
            country: res?.genCountry,
            region: res?.genRegion,
            city: res?.genCity,
            address: res?.genAddress,
            streetNumber: res?.genStreetNumber,
            postalCode: res?.genPostalCode,
            province: res?.genProvince,
            phoneNumber: res?.genPhone,
            cellPhoneNumber: res?.genCellPhone,
            email: res?.genEmail,
            area: res?.genArea,
            finOldIdentificationCode: res?.finOldIdentificationCode,
            dms: res?.procDms,
            agreementDate: res?.procSignDate,

            repCompanyName: res?.repCompanyName,
            repVatNumber: res?.repVatNumber,
            siren: res?.siren,
            siret: res?.siret,
            representativeName: res?.repName,
            representativeEmail: res?.repEmail,
            representativeCellphone: res?.repCellPhone,
            taxCode: res?.repTaxCode,
            sdiCode: res?.repSdiCode,
            representativeContactName: res?.repContactName,
            representativeContactEmail: res?.repContactEmail,
            representativeContactCellphone: res?.repContactCellPhone,
            representativeIban: res?.repIban,
            representativeAddress: res?.repAddress,
            representativeStreetNumber: res?.repStreet,
            representativePostalCode: res?.repPostalCode,
            representativeCity: res?.repCity,
            representativeProvince: res?.repProvince,
            representativeHqCellphone: res?.repCellPhone,
            representativePec: res?.repPec,
            oldCode: res?.oldCode,
            affIncomeCode: res.affIncomeCode
        }
    }

    async function updateProcurer(data: any) {
        let payload = {
            genBpCode: data.genBpCode,
            genVendorCode: data.genVendorCode,
            genStatus: data.status,
            procConCommercial: data.commercialCode,
            recordType: "PROCURER"
        }
        return PUT('sm/affiliationprogram/procurer/', payload, true, null);
    }

    return {
        listProcurers,
        detailProcurer,
        updateProcurer
    }

}